module.exports = __webpack_public_path__ + "img/news.2a7f025d.svg";